var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"search-result search-result-theme"},[_c('router-link',{staticClass:"search-result-name",attrs:{"to":{path: _vm.linkValue}}},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }